const footLinks = [
  { title: "内容导航", items: [{ label: "今日焦点", href: "#focus" }, { label: "频道围观", href: "#channels" }, { label: "大瓜合集", href: "#roundup" }, { label: "热议排行", href: "#rank" }] },
  { title: "加入我们", items: [{ label: "群组讨论", href: "#forum" }, { label: "常见问题", href: "#faq" }, { label: "订阅日报", href: "#newsletter" }] },
  { title: "关注我们", items: [{ label: "新浪微博", href: "#top" }, { label: "微信公众号", href: "#top" }, { label: "今日头条", href: "#top" }, { label: "抖音", href: "#top" }] },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-accent-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-base font-bold text-background-50">
                瓜
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                吃瓜<span className="text-primary-600">聚集地</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              全网热点的聚集地。热门事件实时更新、群组讨论随时开趴，理性围观，快乐吃瓜，一瓜不落。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600">
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600">
                <i className="ri-wechat-fill" aria-hidden="true"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600">
                <i className="ri-qq-line" aria-hidden="true"></i>
              </span>
            </div>
          </div>

          {footLinks.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-3 space-y-2">
                {col.items.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 transition hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-accent-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {year} 吃瓜聚集地 · 理性围观，不信谣不传谣
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <a href="#top" className="transition hover:text-primary-600">网站首页</a>
            <a href="#faq" className="transition hover:text-primary-600">免责声明</a>
            <a href="#faq" className="transition hover:text-primary-600">社区公约</a>
          </div>
        </div>
      </div>
    </footer>
  );
}